module.exports = __webpack_public_path__ + "media/images/site/main_bkg-9ba23cc20388194bd9fab0986d842069.jpg";